import React from 'react';

export const TickIcon = ({ size = '14' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        preserveAspectRatio="xMinYMin slice"
        viewBox="0 0 32 32"
        focusable="false"
        height={size}
        width={size}
    >
        <path fill="none" d="M0 0h32v32H0z"></path>
        <path
            fontWeight="bold"
            stroke="rgba(6,153,7,1)"
            strokeWidth="5"
            fill="rgba(6,153,7,1)"
            fillRule="evenodd"
            d="M30 7l-1.41-1.41L11 23.17 3.41 15.6 2 17l9 9L30 7z"
        ></path>
    </svg>
);
